import { returnErrors } from './errorAction';
import { GET_PLANS, GET_ACCOUNT_DETAIL, VALIDATE_COUPON_CODE, APPLY_CODE, UPDATE_PROFILE, GET_COMPANIES, CREATE_COMPANY, UPDATE_COMPANY_STATUS, UPDATE_COMPANY, GET_CLIENT_COMPANIES, CREATE_CLIENT_COMPANY, UPDATE_CLIENT_COMPANY_STATUS, UPDATE_CLIENT_COMPANY, GET_COMPANY_MEMBERS, ADD_COMPANY_MEMBER, UPDATE_MEMBER_PERMISSIONS, UPDATE_MEMBER_STATUS, GET_MEMBER_BY_ID, GET_COMPANY_ROLES, GET_MODULES, GET_APP_PERMISSIONS, CREATE_COMPANY_ROLE, UPDATE_COMPANY_ROLE, DELETE_COMPANY_ROLE, GET_HIRING_STATUSES, CREATE_HIRING_STATUS, UPDATE_HIRING_STATUS, DELETE_HIRING_STATUS, REORDER_HIRING_STATUSES } from '../Types/types';
import { getApiCall, handle403Logout, postApiCall, } from '../../utils/request';
import { deleteJobApiCall, getJobApiCall, patchJobApiCall, postJobApiCall, putJobApiCall } from '../../utils/jobRequest';


export const getAccountDetail = () => async (dispatch) => {
    try {
        const response = await getApiCall(`setting/account-details`);
        if (response?.status === 200) {
            return dispatch({ type: GET_ACCOUNT_DETAIL, payload: response.data });
        }
        else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const getPlans = () => async (dispatch) => {
    try {
        const response = await getApiCall(`setting/get-payment-plans`);
        if (response?.status === 200) {
            return dispatch({ type: GET_PLANS, payload: response.data.paymentPlans });
        }
        else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const validateCoupon = (code) => async (dispatch) => {
    try {
        const response = await getApiCall(`setting/validate-coupon-code?CouponCode=${code}`);
        if (response?.status === 200) {

            return dispatch({ type: VALIDATE_COUPON_CODE, payload: response.data });
        }
        else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const applyCoupon = (code) => async (dispatch) => {
    try {
        const response = await getApiCall(`setting/apply-coupon-code?CouponCode=${code}`);
        if (response?.status === 200) {
            returnErrors(dispatch, 'Coupon applied succesfully', response?.status)
            return dispatch({ type: APPLY_CODE, payload: response.data });
        }
        else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const updateCompanyProfile = (obj) => async (dispatch) => {
    const data = new FormData();
    data.append('tenantId', obj?.tenantId);
    obj.image && data.append('file', obj.image);
    try {
        const response = await postApiCall(`setting/update-account-details?DisplayName=${obj.name}&websiteName=${obj.website}&languageId=${obj.languageId}&isWhiteLabel=${!!obj.isWhiteLabel}&colour=${encodeURIComponent(obj.colour || '')}`, data);
        if (response?.status === 200) {
            return dispatch({ type: UPDATE_PROFILE, payload: response.data });
        }
        else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const getApiKeys = () => async (dispatch) => {
    try {
        const response = await getJobApiCall(`api-keys/`);
        if (response?.status === 200) {
            return dispatch({ type: 'GET_API_KEYS', payload: response.data });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const createApiKey = (payload) => async (dispatch) => {
    try {
        const response = await postJobApiCall(`api-keys/`, payload);
        if (response?.status === 201) {
            dispatch({ type: 'CREATE_API_KEY', payload: response.data });
            return response.data;
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const revokeApiKey = (id) => async (dispatch) => {
    try {
        const response = await patchJobApiCall(`api-keys/${id}/revoke`);
        if (response?.status === 200) {
            return dispatch({ type: 'REVOKE_API_KEY', payload: response.data });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const deleteApiKey = (id) => async (dispatch) => {
    try {
        const response = await deleteJobApiCall(`api-keys/${id}`);
        if (response?.status === 200) {
            return dispatch({ type: 'DELETE_API_KEY', payload: id });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

// ─── Companies ───────────────────────────────────────────────────────────────

export const getCompanies = (limit = 10, page = 1, options = {}) => async (dispatch) => {
    try {
        const { is_active, search } = options;
        let url = `companies/?page_size=${limit}&page=${page}`;
        if (is_active !== undefined && is_active !== null) {
            url += `&is_active=${is_active}`;
        }
        if (search && String(search).trim()) {
            url += `&search=${encodeURIComponent(String(search).trim())}`;
        }
        const response = await getJobApiCall(url);
        if (response?.status === 200) {
            return dispatch({
                type: GET_COMPANIES,
                payload: {
                    data: Array.isArray(response.data.data) ? response.data.data : [],
                    total: response.data?.pagination?.total ?? 0,
                },
            });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

/** post/put helpers resolve (not reject) with the axios error on 4xx, so the body may be under `.response.data`. */
const apiErrorDetail = (resOrError) => {
    const data = resOrError?.response?.data ?? resOrError?.data;
    return data?.detail || data?.responseMessages?.[0]?.message || data?.message || resOrError?.parsedMessage;
};

const apiErrorStatus = (resOrError) =>
    resOrError?.response?.status || resOrError?.status || resOrError?.parsedStatus;

export const createCompany = (payload) => async (dispatch) => {
    try {
        const response = await postJobApiCall(`companies/`, payload);
        if (response?.status === 200 || response?.status === 201) {
            return dispatch({ type: CREATE_COMPANY, payload: response.data });
        }
        const detail = apiErrorDetail(response);
        returnErrors(dispatch, detail, apiErrorStatus(response));
        return { type: 'CREATE_COMPANY_FAILED', payload: { detail } };
    } catch (error) {
        handle403Logout(error);
        const detail = apiErrorDetail(error);
        returnErrors(dispatch, detail, apiErrorStatus(error));
        return { type: 'CREATE_COMPANY_FAILED', payload: { detail } };
    }
}

export const updateCompanyStatus = (companyId, isActive) => async (dispatch) => {
    try {
        const response = await patchJobApiCall(`companies/${companyId}/status?is_active=${isActive}`);
        if (response?.status === 200 || response?.status === 204) {
            return dispatch({ type: UPDATE_COMPANY_STATUS, payload: { id: companyId, is_active: isActive } });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const updateCompany = (companyId, payload) => async (dispatch) => {
    try {
        const response = await putJobApiCall(`companies/${companyId}`, payload);
        if (response?.status === 200 || response?.status === 204) {
            return dispatch({ type: UPDATE_COMPANY, payload: { id: companyId, ...payload } });
        }
        const detail = apiErrorDetail(response);
        returnErrors(dispatch, detail, apiErrorStatus(response));
        return { type: 'UPDATE_COMPANY_FAILED', payload: { detail } };
    } catch (error) {
        handle403Logout(error);
        const detail = apiErrorDetail(error);
        returnErrors(dispatch, detail, apiErrorStatus(error));
        return { type: 'UPDATE_COMPANY_FAILED', payload: { detail } };
    }
}

export const getCompanyById = (companyId) => async (dispatch) => {
    try {
        const response = await getJobApiCall(`companies/${companyId}`);
        if (response?.status === 200) {
            const data = response.data?.data ?? response.data;
            return dispatch({ type: UPDATE_COMPANY, payload: data });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

// ─── Client Companies ────────────────────────────────────────────────────────

export const getClientCompanies = (limit = 10, page = 1, options = {}) => async (dispatch) => {
    try {
        const { is_active, search } = options;
        let url = `client-companies/?page_size=${limit}&page=${page}`;
        if (is_active !== undefined && is_active !== null) {
            url += `&is_active=${is_active}`;
        }
        if (search && String(search).trim()) {
            url += `&search=${encodeURIComponent(String(search).trim())}`;
        }
        const response = await getJobApiCall(url);
        if (response?.status === 200) {
            return dispatch({
                type: GET_CLIENT_COMPANIES,
                payload: {
                    data: Array.isArray(response.data.data) ? response.data.data : [],
                    total: response.data?.pagination?.total ?? 0,
                },
            });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const createClientCompany = (payload) => async (dispatch) => {
    try {
        const response = await postJobApiCall(`client-companies/`, payload);
        if (response?.status === 200 || response?.status === 201) {
            const id = response.data?.data ?? response.data;
            return dispatch({
                type: CREATE_CLIENT_COMPANY,
                payload: { id, name: payload.name, code: payload.code, is_active: true },
            });
        }
        const detail = apiErrorDetail(response);
        returnErrors(dispatch, detail, apiErrorStatus(response));
        return { type: 'CREATE_CLIENT_COMPANY_FAILED', payload: { detail } };
    } catch (error) {
        handle403Logout(error);
        const detail = apiErrorDetail(error);
        returnErrors(dispatch, detail, apiErrorStatus(error));
        return { type: 'CREATE_CLIENT_COMPANY_FAILED', payload: { detail } };
    }
}

export const updateClientCompanyStatus = (clientCompanyId, isActive) => async (dispatch) => {
    try {
        const response = await patchJobApiCall(`client-companies/${clientCompanyId}/status?is_active=${isActive}`);
        if (response?.status === 200 || response?.status === 204) {
            return dispatch({ type: UPDATE_CLIENT_COMPANY_STATUS, payload: { id: clientCompanyId, is_active: isActive } });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const updateClientCompany = (clientCompanyId, payload) => async (dispatch) => {
    try {
        const response = await putJobApiCall(`client-companies/${clientCompanyId}`, payload);
        if (response?.status === 200 || response?.status === 204) {
            return dispatch({ type: UPDATE_CLIENT_COMPANY, payload: { id: clientCompanyId, ...payload } });
        }
        const detail = apiErrorDetail(response);
        returnErrors(dispatch, detail, apiErrorStatus(response));
        return { type: 'UPDATE_CLIENT_COMPANY_FAILED', payload: { detail } };
    } catch (error) {
        handle403Logout(error);
        const detail = apiErrorDetail(error);
        returnErrors(dispatch, detail, apiErrorStatus(error));
        return { type: 'UPDATE_CLIENT_COMPANY_FAILED', payload: { detail } };
    }
}

export const getClientCompanyById = (clientCompanyId) => async (dispatch) => {
    try {
        const response = await getJobApiCall(`client-companies/${clientCompanyId}`);
        if (response?.status === 200) {
            const data = response.data?.data ?? response.data;
            return dispatch({ type: UPDATE_CLIENT_COMPANY, payload: data });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

// ─── Company Members ──────────────────────────────────────────────────────────

export const getCompanyMembers = (companyId, pageSize = 10, page = 1, search = '') => async (dispatch) => {
    try {
        let url = `company-members?page_size=${pageSize}&page=${page}`;
        if (companyId) {
            url += `&company_id=${companyId}`;
        }
        if (search && String(search).trim()) {
            url += `&search=${encodeURIComponent(String(search).trim())}`;
        }
        const response = await getJobApiCall(url);
        if (response?.status === 200) {
            return dispatch({ type: GET_COMPANY_MEMBERS, payload: response.data });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const addCompanyMember = (companyId, payload) => async (dispatch) => {
    try {
        const response = await postJobApiCall(`companies/${companyId}/members`, payload);
        if (response?.status === 200 || response?.status === 201) {
            return dispatch({ type: ADD_COMPANY_MEMBER, payload: response.data });
        }
        const detail = apiErrorDetail(response);
        returnErrors(dispatch, detail, apiErrorStatus(response));
        return { type: 'ADD_COMPANY_MEMBER_FAILED', payload: { detail } };
    } catch (error) {
        handle403Logout(error);
        const detail = apiErrorDetail(error);
        returnErrors(dispatch, detail, apiErrorStatus(error));
        return { type: 'ADD_COMPANY_MEMBER_FAILED', payload: { detail } };
    }
}

export const getCompanyRoles = () => async (dispatch) => {
    try {
        const response = await getJobApiCall(`app-rbac/roles`);
        if (response?.status === 200) {
            const roles = Array.isArray(response.data)
                ? response.data
                : Array.isArray(response.data?.data)
                    ? response.data.data
                    : [];
            return dispatch({ type: GET_COMPANY_ROLES, payload: roles });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const getModules = () => async (dispatch) => {
    try {
        const response = await getJobApiCall(`app-rbac/modules`);
        if (response?.status === 200) {
            const modules = Array.isArray(response.data)
                ? response.data
                : Array.isArray(response.data?.data)
                    ? response.data.data
                    : [];
            return dispatch({ type: GET_MODULES, payload: modules });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const getAppPermissions = () => async (dispatch) => {
    try {
        const response = await getJobApiCall(`app-rbac/permissions`);
        if (response?.status === 200) {
            const permissions = Array.isArray(response.data)
                ? response.data
                : Array.isArray(response.data?.data)
                    ? response.data.data
                    : [];
            return dispatch({ type: GET_APP_PERMISSIONS, payload: permissions });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message || error?.parsedMessage, error?.response?.status || error?.parsedStatus);
    }
}

export const createCompanyRole = (payload) => async (dispatch) => {
    try {
        const response = await postJobApiCall(`app-rbac/roles`, payload);
        if (response?.status === 200 || response?.status === 201) {
            const role = response.data?.data ?? response.data;
            return dispatch({ type: CREATE_COMPANY_ROLE, payload: role });
        }
        const failDetail = apiErrorDetail(response);
        returnErrors(dispatch, failDetail, apiErrorStatus(response));
        return { type: 'CREATE_COMPANY_ROLE_FAILED', payload: { detail: failDetail } };
    } catch (error) {
        handle403Logout(error);
        const detail = apiErrorDetail(error);
        returnErrors(dispatch, detail, apiErrorStatus(error));
        return { type: 'CREATE_COMPANY_ROLE_FAILED', payload: { detail } };
    }
}

export const updateCompanyRole = (roleId, payload) => async (dispatch) => {
    try {
        const response = await putJobApiCall(`app-rbac/roles/${roleId}`, payload);
        if (response?.status === 200) {
            const role = response.data?.data ?? response.data;
            return dispatch({ type: UPDATE_COMPANY_ROLE, payload: role });
        }
        const failDetail = apiErrorDetail(response);
        returnErrors(dispatch, failDetail, apiErrorStatus(response));
        return { type: 'UPDATE_COMPANY_ROLE_FAILED', payload: { detail: failDetail } };
    } catch (error) {
        handle403Logout(error);
        const detail = apiErrorDetail(error);
        returnErrors(dispatch, detail, apiErrorStatus(error));
        return { type: 'UPDATE_COMPANY_ROLE_FAILED', payload: { detail } };
    }
}

export const deleteCompanyRole = (roleId) => async (dispatch) => {
    try {
        const response = await deleteJobApiCall(`app-rbac/roles/${roleId}`);
        if (response?.status === 200 || response?.status === 204) {
            return dispatch({ type: DELETE_COMPANY_ROLE, payload: roleId });
        }
        const failDetail = apiErrorDetail(response);
        returnErrors(dispatch, failDetail, apiErrorStatus(response));
        return { type: 'DELETE_COMPANY_ROLE_FAILED', payload: { detail: failDetail } };
    } catch (error) {
        handle403Logout(error);
        const detail = apiErrorDetail(error);
        returnErrors(dispatch, detail, apiErrorStatus(error));
        return { type: 'DELETE_COMPANY_ROLE_FAILED', payload: { detail } };
    }
}

export const updateMemberPermissions = (memberId, payload) => async (dispatch) => {
    try {
        const response = await patchJobApiCall(`user-management/members/${memberId}/permissions`, payload);
        if (response?.status === 200) {
            return dispatch({ type: UPDATE_MEMBER_PERMISSIONS, payload: response.data });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const updateMemberStatus = (companyUserId, isActive) => async (dispatch) => {
    try {
        const response = await patchJobApiCall(`company-members/${companyUserId}/status?is_active=${isActive}`);
        if (response?.status === 200) {
            return dispatch({ type: UPDATE_MEMBER_STATUS, payload: { id: companyUserId, is_active: isActive } });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const getMemberById = (companyUserId) => async (dispatch) => {
    try {
        const response = await getJobApiCall(`company-members/${companyUserId}`);
        if (response?.status === 200) {
            const data = response.data?.data ?? response.data;
            return dispatch({ type: GET_MEMBER_BY_ID, payload: data });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

// ─── Checkout ─────────────────────────────────────────────────────────────────

export const createCheckout = (planId) => async (dispatch) => {
    try {
        const response = await postJobApiCall(`payments/checkout`, {
            plan_id: planId,
            mode: 'subscription',
            currency: 'USD',
            country: 'US',
            gateway_code: 'paypal',
            idempotency_key: crypto.randomUUID(),
            success_url: window.location.origin + '/billing/success',
            cancel_url: window.location.origin + '/billing/cancel',
        });
        if (response?.status === 200 || response?.status === 201) {
            return dispatch({ type: 'CREATE_CHECKOUT', payload: response.data });
        } else {
            returnErrors(dispatch, response?.data?.message || response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const cancelCheckout = (orderId) => async (dispatch) => {
    try {
        const response = await postJobApiCall(`payments/checkout/${orderId}/cancel`);
        if (response?.status === 200 || response?.status === 204) {
            return dispatch({ type: 'CANCEL_CHECKOUT', payload: response.data });
        } else {
            returnErrors(dispatch, response?.data?.message || response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

// ─── Hiring Statuses ──────────────────────────────────────────────────────────

export const getHiringStatuses = () => async (dispatch) => {
    try {
        const response = await getJobApiCall(`hiring-statuses/`);
        if (response?.status === 200) {
            const data = Array.isArray(response.data?.data) ? response.data.data : Array.isArray(response.data) ? response.data : [];
            return dispatch({ type: GET_HIRING_STATUSES, payload: data });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const createHiringStatus = (name) => async (dispatch) => {
    try {
        const response = await postJobApiCall(`hiring-statuses/`, { name });
        if (response?.status === 200 || response?.status === 201) {
            return dispatch({ type: CREATE_HIRING_STATUS, payload: response.data?.data ?? response.data });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const updateHiringStatus = (id, name) => async (dispatch) => {
    try {
        const response = await patchJobApiCall(`hiring-statuses/${id}`, { name });
        if (response?.status === 200) {
            return dispatch({ type: UPDATE_HIRING_STATUS, payload: response.data?.data ?? response.data });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const deleteHiringStatus = (id) => async (dispatch) => {
    try {
        const response = await deleteJobApiCall(`hiring-statuses/${id}`);
        if (response?.status === 200 || response?.status === 204) {
            return dispatch({ type: DELETE_HIRING_STATUS, payload: id });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const reorderHiringStatuses = (orderedIds) => async (dispatch) => {
    try {
        const response = await putJobApiCall(`hiring-statuses/reorder`, { ordered_ids: orderedIds });
        if (response?.status === 200) {
            const data = Array.isArray(response.data?.data) ? response.data.data : Array.isArray(response.data) ? response.data : [];
            return dispatch({ type: REORDER_HIRING_STATUSES, payload: data });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const syncCheckout = (orderId) => async (dispatch) => {
    try {
        const response = await postJobApiCall(`payments/checkout/${orderId}/sync-from-gateway`);
        if (response?.status === 200 || response?.status === 201) {
            return dispatch({ type: 'SYNC_CHECKOUT', payload: response.data });
        } else {
            returnErrors(dispatch, response?.data?.message || response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}
